<template>
  <div>
    <a-card title="更新活动" :bordered="false">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="活动名称"
        >
          <a-input
            v-decorator="[
          'name',
          
          {rules: [{ required: true, message: '必填项' }],initialValue: formData.name,}
        ]"
            placeholder="活动名称"
          />
          <a-input
            v-decorator="[
          'id',
          {initialValue: formData.id},
          {rules: [{ required: true, message: '必填项' }]}
        ]"
            placeholder="ID"
            type="hidden"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="活动时间"
        >
          <a-range-picker
            style="width: 100%"
            @change="onDateChange"
            v-decorator="[
          'eventTime',
          {rules: [{ required: true, message: '必填项' }],
          initialValue:[ moment(this.startTime, this.dateFormat),
          moment(this.endTime, this.dateFormat)]}
          ]"
          />
        </a-form-item>

        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          label="说明"
        >
          <a-input
            v-decorator="[
          'note',
          {initialValue: formData.note}
        ]"
            placeholder="说明"
          />
        </a-form-item>

        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
          <div>
            <a-button type="primary" html-type="submit">提交</a-button>&nbsp;
            <a-button @click="goBack">取消</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>
<script>
const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8 }
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 }
};
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  name: "eventUpdate",
  created() {
    this.$http.get("/api/1.0/event/get/" + this.$route.params.id).then(res => {
      this.formData = res.data;
      this.startTime = this.formData.startTime;
      this.endTime = this.formData.endTime;
    });
  },
  mount() {},
  data() {
    return {
      mode2: ["day", "day"],
      dateFormat: "YYYY-MM-DD",
      formItemLayout,
      formTailLayout,
      formData: {},
      startTime: "",
      endTime: "",
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          values["startTime"] = this.startTime;
          values["endTime"] = this.endTime;
          this.$http.post("/api/1.0/event/update", values).then(res => {
            this.$http.ajaxResultDue(res, "/event", null);
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    moment,
    onDateChange(dates, dateStrings) {
      this.startTime = dateStrings[0];
      this.endTime = dateStrings[1];
    }
  }
};
</script>
<style scoped>
.ant-input-number {
  width: 100%;
}
</style>

